import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { NotificationProvider, AuthProvider, MainLayout } from "@vionixasia/shared-components";

import { Beranda } from "./Beranda";
import { ServicePage } from "./pages/ServicePage";

import {
  Login,
  LupaPassword,
  Register,
  Verify,

  KebijakanPrivasi,
  SyaratKetentuan,
  Profile,
} from "@vionixasia/shared-components";

// Komponen untuk halaman 404
const NotFound = () => (
  <section className="w-full min-h-screen py-20 text-center text-slate-700 flex-col justify-center relative bg-white flex">
    <h2 className="text-xl sm:text-2xl md:text-3xl font-normal uppercase mb-2 text-slate-700 tracking-widest">
      PAGE
    </h2>
    <p className="text-4xl sm:text-5xl md:text-7xl font-black mx-auto mb-10 text-slate-700 px-4">
      NOT FOUND
    </p>

    <p className="text-lg text-slate-500 mb-10 px-6">
      The page you are looking for doesn’t exist or has been moved.
    </p>
  </section>
);

/* (Optional) Loading Fallback */
const LoadingFallback = () => (
  <div className="w-full min-h-screen flex items-center justify-center bg-white">
    <div className="text-center text-slate-700">
      <p className="text-xl font-semibold">Loading...</p>
    </div>
  </div>
);

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: sectionId } });
      return;
    }

    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const menuItems = [
    { label: "About Us", onClick: () => scrollToSection("who-we-are") },
    { label: "Our Services", onClick: () => scrollToSection("services") },
    { label: "Testimonials", onClick: () => scrollToSection("testimonials") },
    { label: "Why Choose Us", onClick: () => scrollToSection("why-choose-us") },
    { label: "Contact Us", onClick: () => scrollToSection("contact") },
  ];

  return (
    <AuthProvider>
      <NotificationProvider>

        <Suspense fallback={<LoadingFallback />}>
          <MainLayout appName="MAIN" menuItems={menuItems} className="bg-white" showFooter={false}>
            <Routes>
              <Route index element={<Beranda />} />
              <Route path="KebijakanPrivasi" element={<KebijakanPrivasi />} />
              <Route path="SyaratKetentuan" element={<SyaratKetentuan />} />
              <Route path="profile" element={<Profile />} />
              <Route path="Profile" element={<Profile />} />
              <Route path="services/:slug" element={<ServicePage />} />
              {/* Rute 404 */}
              <Route path="*" element={<NotFound />} />
              
              {/* Rute Autentikasi */}
              <Route path="login" element={<Login />} />
              <Route path="register" element={<Register />} />
              <Route path="verify" element={<Verify />} />
              <Route path="lupapassword" element={<LupaPassword />} />
            </Routes>
          </MainLayout>
        </Suspense>
      </NotificationProvider>
    </AuthProvider>
  );
};

export default App;
